import { useAppDispatch } from '@/shared/hooks/useStore';
import { fetchVersionManifest } from '@/viewmodel/shared/versionCheck/releaseFiles';
import { updateDetected } from '@/viewmodel/shared/versionCheck/state/versionCheckSlice';
import { useEffect } from 'react';

const POLL_INTERVAL_MS = 5 * 60 * 1000;

export function useVersionPolling(): void {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const currentVersion = import.meta.env.VITE_APP_VERSION;
    if (!currentVersion) return;

    let cancelled = false;

    const check = async (): Promise<void> => {
      const manifest = await fetchVersionManifest();
      if (cancelled || !manifest) return;
      if (manifest.version !== currentVersion) {
        dispatch(updateDetected(manifest.version));
      }
    };

    const onVisibilityChange = (): void => {
      if (document.visibilityState === 'visible') void check();
    };

    void check();
    const interval = setInterval(() => void check(), POLL_INTERVAL_MS);
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [dispatch]);
}
